export default null;throw new Error("Unable to resolve \"../../is-buffer/index.js\" from npm:pngjs@5.0.0/browser.js");